// this module will have the  user data that needs to be shared across the app, we might consider persisting this to a local storage later.
import {
  get,
  post
} from "../../API/cloudFunctions";

const User = {
  state: {
    projects: [],
    authenticated: false,
    currentUser: JSON.parse(localStorage.getItem("currentUser")) || {},
    analytics_view: JSON.parse(localStorage.getItem("AnalyticsView")) || []
  },

  mutations: {
    GET_PROJECTS: (state, projects) => {
      state.projects = projects;
    },

    ADD_Project: (state, project) => {
      console.log("added project ", project);
      state.projects.push(project);
    },

    GET_PROJECT_BY_ID: (state, projectId) => {
      return state.projects.find(project => {
        console.log("project gateways", project);
        return project.id === projectId;
      });
    },

    DELETE_PROJECT: (state, projectId) => {
      let projectIndex = state.projects.findIndex(
        project => project.id === projectId
      );
      if (projectIndex !== -1) {
        state.projects.splice(projectIndex, 1);
      } else {
        console.error("the deleted project is unavailable.");
      }
    },

    GET_DEVICES: (state, payload) => {
      console.log("log ", payload);
      console.log("state", state.projects);
      if (state.projects.length !== 0) {
        state.projects.find(item => {
          return item.id === payload.projectId;
        }).gateways = payload.gateways;
      }
    },

    ADD_GATEWAY: (state, payload) => {
      let gateway = payload.data.gateway;
      gateway.sensors = payload.data.sensors;
      console.log("gateway to be pushed to vuex", gateway);
      let project = state.projects.find(project => {
        return project.id === gateway.idProject;
      });

      if (project.gateways) {
        project.gateways.push(gateway);
      } else {
        project.gateways = [];
        project.gateways.push(gateway);
      }
    },

    DELETE_GATEWAY: (state, payload) => {
      console.log("gate way being deleted", payload);

      let gateways = state.projects.find(project => {
        return payload.idProject === project.id;
      }).gateways;

      let gatewayIndex = gateways.findIndex(
        gateway => gateway.id === payload.id
      );

      if (gatewayIndex) {
        gateways.splice(gatewayIndex, 1);
      }
    },

    ADD_DEVICE: (state, payload) => {
      let device = payload.data.data.device;
      device.sensors = payload.data.data.sensors;
      console.log(
        "device to be pushed to vuex",
        device,
        "project id",
        payload.idProject
      );
      let project = state.projects.find(project => {
        return project.id === payload.idProject;
      });
      let gateway = project.gateways.find(gateway => {
        return gateway.id === device.idParent;
      });
      console.log("gate way that the device would be pushed to", gateway);

      if (gateway.devices) {
        gateway.devices.push(device);
      } else {
        gateway.devices = [];
        gateway.devices.push(device);
      }
    },
    GET_GATEWAY_ALERTS: (state, payload) => {
      console.log("gateway alerts ", payload);
    },

    EDIT_DEVICE: (state, payload) => {
      if (payload.idProject != "-1") {
        let gateways = state.projects.find(project => {
          return project.id === payload.idProject;
        }).gateways;
        if (gateways && gateways.length > 0) {
          let gateway = gateways.find(gateway => gateway.id === payload.id);
          gateway.name = payload.name;
          gateway.coordinates = payload.coordinates;
        } else {
          console.error("gateways is undefined or empty !");
        }
      } else {}
    },

    DELETE_DEVICE: (state, payload) => {
      console.log("gate way being deleted", payload);

      let gateways = state.projects.find(project => {
        return payload.gateway.idProject === project.id;
      }).gateways;

      let gateway = gateways.find(gateway => gateway.id === payload.gateway.id);

      let deviceIndex = gateway.devices.findIndex(
        device => device.id === payload.device.id
      );

      if (deviceIndex !== -1) {
        gateway.devices.splice(deviceIndex, 1);
      }
    },

    ADD_VIEW: (state, payload) => {
      state.analytics_view.push(payload);
      localStorage.setItem(
        "AnalyticsView",
        JSON.stringify(state.analytics_view)
      );
    },

    UPDATE_VIEW: (state, payload) => {
      let view = state.analytics_view.find(view => view.id === payload.id);
      view.name = payload.updates.name;
      localStorage.setItem(
        "AnalyticsView",
        JSON.stringify(state.analytics_view)
      );
    },
    SET_VIEWS: (state, payload) => {
      state.analytics_view = payload;
      localStorage.setItem(
        "AnalyticsView",
        JSON.stringify(state.analytics_view)
      );
    }
  },

  actions: {
    getProjects({
      commit
    }) {
      return new Promise((resolve, reject) => {
        get("getProjectList")
          .then(success => {
            resolve(success);
            commit("GET_PROJECTS", success);
          })
          .catch(error => {
            reject(error);
            console.error("unable to get user projects", error);
          });
      });
    },

    addProject({
      commit
    }, project) {
      let projectlocal = project;
      return new Promise((resolve, reject) => {
        post("addProject", project)
          .then(success => {
            projectlocal.id = success.id;
            commit("ADD_Project", projectlocal);
            resolve({
              success: true
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    deleteProject({
      commit
    }, projectId) {
      return new Promise((resolve, reject) => {
        post("deleteProject", {
            idProject: projectId
          })
          .then(success => {
            commit("DELETE_PROJECT", projectId);

            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getGatewayAlerts({
      commit,
      state
    }, gatewayId) {
      return new Promise((resolve, reject) => {
        post("getGatewayAlerts", {
            idGateway: gatewayId
          })
          .then(alerts => {
            commit("GET_GATEWAY_ALERTS", {
              alerts,
              gatewayId
            });
            resolve(alerts);

          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
      });
    },
    getProjectDevices({
      commit,
      state
    }, projectId) {
      return new Promise((resolve, reject) => {
        post("getDevicesByProjectId", {
            idProject: projectId
          })
          .then(gateways => {
            commit("GET_DEVICES", {
              gateways,
              projectId
            });
            resolve(gateways);

          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
      });
    },

    addGateway({
      commit
    }, payload) {
      let payloadLocal = payload;

      return new Promise((resolve, reject) => {
        post("addDevice", payloadLocal)
          .then(success => {
            resolve(success.result[success.result.length - 1].data);
            //the id's of the sensor are generated in the cloud and they need to be appended back
            payloadLocal.data.sensors = success.result.find(
              item => item.sensors
            ).sensors;
            commit("ADD_GATEWAY", payloadLocal);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    deleteGateway({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        post("deleteDevice", {
            idDevice: payload.id
          })
          .then(success => {
            commit("DELETE_GATEWAY", payload);

            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    addDevice({
      commit
    }, payload) {
      let payloadLocal = payload;
      return new Promise((resolve, reject) => {
        post("addDevice", payloadLocal.data)
          .then(success => {
            resolve(success.result[success.result.length - 1].data);
            payloadLocal.data.data.sensors = success.result.find(
              item => item.sensors
            ).sensors;
            console.log("sensors vuex", payloadLocal.data.data.sensors);
            commit("ADD_DEVICE", payloadLocal);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    editDevice({
      commit
    }, payload) {
      console.log("editting the device");
      return new Promise((resolve, reject) => {
        post("updateDevice", {
            id: payload.id,
            updates: {
              name: payload.name,
              coordinates: payload.coordinates
            }
          })
          .then(success => {
            commit("EDIT_DEVICE", payload);

            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    deleteDevice({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        post("deleteDevice", {
            idDevice: payload.device.id
          })
          .then(success => {
            commit("DELETE_DEVICE", payload);
            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getProjectById({
      commit,
      state
    }, projectId) {
      return new Promise((resolve, reject) => {
        resolve(commit("GET_PROJECT_BY_ID", projectId));
      });
    },

    getAnalyticsView({
      commit
    }) {
      return new Promise((resolve, reject) => {
        post("getUserViews")
          .then(success => {
            commit("SET_VIEWS", success);
            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addAnalyticsView({
      commit
    }, payload) {
      let view = payload.view;
      return new Promise((resolve, reject) => {
        post("addView", {
            view: payload.view
          })
          .then(success => {
            view.id = success.id;
            commit("ADD_VIEW", view);
            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateAnalyticsView({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        post("updateView", payload)
          .then(success => {
            commit("UPDATE_VIEW", payload);
            resolve(success);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

function ItemIndexInArrayWithId(array, id) {
  return array.findIndex(item => item.id === id);
}

export default User;



// WEBPACK FOOTER //
// ./src/store/modules/User.js